import { createContext, useContext } from 'react';

// Every "KinezioLetter" CTA opens the same GHL sign-up form (GhlFormModal, see App.tsx).
export const NewsletterContext = createContext<() => void>(() => {});

export const useOpenNewsletter = () => useContext(NewsletterContext);
